import { PageResponse } from '@/lib/types';

export const getLeafSlug = (slug: string): string =>
  slug.includes('/') ? slug.split('/').pop()! : slug;

export const buildSubPageHref = (parentTo: string | undefined, subPageSlug: string): string => {
  if (subPageSlug === 'home') return '/';
  const normalizedParent = parentTo === '/' ? 'home' : parentTo;
  const parentSlug = normalizedParent ? normalizedParent.replace(/^\//, '') : '';
  const leaf = getLeafSlug(subPageSlug);
  return parentSlug ? `/${parentSlug}/${leaf}` : `/${leaf}`;
};

export const isStoreRoute = (href?: string): boolean => {
  if (!href) {
    return false;
  }

  const path = href.split('?')[0].split('#')[0];
  return path === '/store';
};

export const getRedirectPath = (
  pages: PageResponse[] | undefined
): string => {
  if (!pages || pages.length === 0) return '/';

  const homePage = pages.find((p) => p.slug === 'home');

  if (homePage) return '/';

  const candidates = pages
    .filter((p) => !['store'].includes(p.slug) && !p.isSubPage)
    .sort((a, b) => a.priority - b.priority);

  if (candidates.length > 0) {
    return `/${getLeafSlug(candidates[0].slug)}`;
  }

  return '/';
};
